import TitleListTab from './subpages/title-lists-tab/route'
import ContentTab from './subpages/contect-tab/route'
import SubscriptionsTab from './subpages/subscriptions-tab/route'
import NotesTasksTab from './subpages/notes-tasks/route'

export default {
  path: '/products/:id',
  component: () => import(/* webpackChunkName: "product-show" */ './ProductShow'),
  props: true,
  meta: {
    requiresAuth: true
  },
  redirect: '/products/:id/title-lists',
  children: [TitleListTab, ContentTab, SubscriptionsTab, NotesTasksTab]
}
